import { Instagram } from "lucide-react";
import { INSTAGRAM_URL } from "@/data/content";

export const InstagramButton = ({ className = "", label = true }) => (
  <a
    href={INSTAGRAM_URL}
    target="_blank"
    rel="noreferrer"
    aria-label="Nexora Events on Instagram"
    data-testid="instagram-button"
    className={label ? `btn-ghost ${className}` : `w-11 h-11 rounded-full bg-cream/80 border border-terra/25 text-ink flex items-center justify-center hover:border-terra hover:text-terra-deep transition-colors ${className}`}
  >
    <Instagram size={17} />
    {label && <span>@nexoraevents.in</span>}
  </a>
);
